import React, { Component } from 'react';
import _ from 'lodash';
import moment from 'moment';

import {
  FormElement,
  FormListItem,
  FormListSubHeader,
  TextInput,
} from './CommonFormComponents';
import { DATE_TIME_FORMAT, EXISTANCE_FLAG } from '../utilities/constants';
import { RadioButtonIcon } from './icons/RadioButtonIcon';
import { ArrowDownIcon } from './icons/ArrowDownIcon';
import AttachDocument from './forms/AttachDocument';
import { DateInput } from './DateInput';
import { Description } from './Description';
import {
  ATTACH_DOCUMENT_TYPE_COMPANY,
  PREFECTURE_GROUPS,
} from '../utilities/constants';
import { convertDate, stringToDate } from '../utilities/validateDateUtil';
import { validationByJoi } from '../utilities/commonValidation';
import { isNullOrEmpty } from '../utilities/stringUtil';
import {
  attachDocumentCompanyUploadState,
  attachDocumentDeleteState,
} from '../utilities/attachDocumentUtil';
import { companySecuritySaftyEditSchema } from '../utilities/validationSchemas/companySaftyEdit';
import { messageUtility } from '../utilities/messageUtility';
import {
  isEmptyOrValidInputDate,
  wrapperValidExpirationDate,
} from '../utilities/dateSelectorUtility';

const FORM_STATUS = {
  SHOW: 1,
  NOT_SHOW: 0,
};
class CompanySecurityInformation extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showFormFlag: FORM_STATUS.NOT_SHOW,
      formValues: {},
      validate: {
        invalid: false,
        messages: {},
      },
      warningMsg: {
        license_update_date: '',
      },
    };
    this.formEvents = {
      handleOnChange: this.handleOnChange,
      handleValidate: this.handleValidate,
      handleOnChangeDate: this.handleOnChangeDate,
      deleteFile: this.deleteFile,
      uploadFile: this.uploadFile,
      download: this.props.events.download,
    };
    this.schema = companySecuritySaftyEditSchema();
    this.tempErrorMessages = null;
  }

  componentDidMount() {
    this.initFormValue();
  }

  componentDidUpdate(prevProps) {
    if (!_.isEqual(prevProps.messages, this.props.messages)) {
      this.setState({
        validate: {
          invalid: _.has(
            this.props.messages,
            'security_company_branch_permission_group'
          ),
          messages:
            _.get(
              this.props.messages,
              'security_company_branch_permission_group'
            ) || {},
        },
      });
    }
    if (
      !_.isEqual(
        prevProps.companySecurityValues.id,
        this.props.companySecurityValues.id
      )
    ) {
      this.initFormValue();
    }
  }

  initFormValue = () => {
    const { companySecurityValues } = this.props;
    if (companySecurityValues) {
      this.setState(
        {
          formValues: {
            prefectures_code_id: companySecurityValues.prefectures_code_id,
            permission_number_r: companySecurityValues.permission_number_r,
            license_update_date: companySecurityValues.license_update_date,
            company_documents: companySecurityValues.company_documents || [],
          },
          showFormFlag: companySecurityValues.security_company_branch_permission_flag
            ? EXISTANCE_FLAG.EXIST.VALUE
            : EXISTANCE_FLAG.NOEXIST.VALUE,
        },
        () => !this.props.readOnly && this.handleValidateAll()
      );
    }
  };

  /**
   * Update status show form and set security_company_branch_permission_group
   * @param {object} event: event input
   */
  updateStatusShowForm = event => {
    const { value } = event.target;
    this.setState(
      {
        showFormFlag: Number(value),
      },
      () => {
        this.handleValidateAll();
      }
    );
    this.props.events.setFormValue(
      'security_company_branch_permission_group',
      event
    );
  };

  handleToggleShowForm = event => {
    const {
      companySecurityValues: { company_branch_permission_id: id },
      events: { handleDeletePermissionExistGreenFile },
    } = this.props;
    if (
      _.isFunction(handleDeletePermissionExistGreenFile) &&
      Number(event.target.value) === EXISTANCE_FLAG.NOEXIST.VALUE &&
      id
    ) {
      event.persist();
      handleDeletePermissionExistGreenFile([id], () =>
        this.updateStatusShowForm(event)
      );
    } else {
      this.updateStatusShowForm(event);
    }
  };

  handleOnChange = e => {
    const { value, name } = e.target;
    this.setState(
      {
        formValues: {
          ...this.state.formValues,
          [name]: value,
        },
      },
      () => {
        this.props.setFormValuesSecurityCompanyPermission(
          this.state.validate,
          this.state.formValues
        );
      }
    );
  };

  handleOnChangeDate = (value, name) => {
    this.setState({
      formValues: {
        ...this.state.formValues,
        [name]: value,
      },
    });
  };

  handleValidateAll = () => {
    const validate = _.cloneDeep(this.state.validate);
    if (!this.state.showFormFlag) {
      this.tempErrorMessages = { ...validate.messages };
      validate.messages = {};
      validate.invalid = false;
    } else {
      const values = {
        security_company_branch_permission_group: this.state.formValues,
      };
      const result = validationByJoi(this.schema, values);
      if (!result.status) {
        _.each(
          result.messages.security_company_branch_permission_group,
          (message, key) => {
            validate.messages[key] = message;
          }
        );
      } else {
        validate.messages = {};
      }

      if (!this.isShowWarning()) {
        validate.messages = { ...this.tempErrorMessages };
      }
      validate.invalid = !_.isEmpty(validate.messages);
    }
    this.setState({
      validate,
      warningMsg: {
        ...this.state.warningMsg,
        license_update_date: this.handleWarningLicenseUpdateDate(validate),
      },
    });
    this.props.setFormValuesSecurityCompanyPermission(
      validate,
      this.state.formValues
    );
  };

  handleValidate = (e, name) => {
    const values = {
      security_company_branch_permission_group: { ...this.state.formValues },
    };
    const { validate } = _.cloneDeep(this.state);
    const result = validationByJoi(this.schema, values);
    if (name) {
      if (
        _.has(
          result.messages,
          `security_company_branch_permission_group.${name}`
        )
      ) {
        validate.messages[name] =
          result.messages.security_company_branch_permission_group[name];
      } else if (validate.messages[name]) {
        validate.messages = _.omit(validate.messages, name);
      }
      validate.invalid = !_.isEmpty(
        _.get(
          result.messages,
          `security_company_branch_permission_group.${name}`
        )
      );
    }

    this.setState({
      validate,
      warningMsg: {
        ...this.state.warningMsg,
        license_update_date: this.handleWarningLicenseUpdateDate(validate),
      },
    });
    this.props.setFormValuesSecurityCompanyPermission(
      validate,
      this.state.formValues
    );
    return validate.invalid;
  };

  handleWarningLicenseUpdateDate = validate => {
    if (_.get(validate.messages, 'license_update_date')) {
      return '';
    }
    const licenseUpdateDate =
      _.get(this.state.formValues, 'license_update_date') || null;
    const date = moment(licenseUpdateDate);
    if (date.isValid()) {
      if (
        date.isSameOrBefore(
          moment()
            .add(-5, 'years')
            .format(DATE_TIME_FORMAT.slashDateFormat)
        )
      ) {
        return messageUtility.getMessage('E-001-419');
      }
    }
    return '';
  };

  handleValidateFile = () => {
    const validate = _.cloneDeep(this.state.validate);
    if (!this.state.showFormFlag) {
      validate.messages = {};
      validate.invalid = false;
    } else {
      validate.invalid = !this.filesCheck();
    }
    this.setState({ validate });
    this.props.setFormValuesSecurityCompanyPermission(
      validate,
      this.state.formValues
    );
  };

  filesCheck = () => {
    const { company_documents: files } = _.cloneDeep(this.state.formValues);
    return !_.some(files, file => file.invalidSize || file.invalidType || file.invalidName);
  };

  uploadFile = async (file, typeL, typeS) => {
    attachDocumentCompanyUploadState(
      this.state.formValues.company_documents,
      documents => {
        this.setState(
          {
            formValues: {
              ...this.state.formValues,
              company_documents: documents,
            },
          },
          this.handleValidateFile
        );
      },
      this.props.companyId,
      file,
      typeL,
      typeS
    );
  };

  deleteFile = file => {
    attachDocumentDeleteState(
      this.state.formValues.company_documents,
      documents => {
        this.setState(
          {
            formValues: {
              ...this.state.formValues,
              company_documents: documents,
            },
          },
          this.handleValidateFile
        );
      },
      file
    );
  };

  renderRegistrationSecurity = () => {
    const { readOnly } = this.props;
    const { showFormFlag } = this.state;
    return (
      <FormElement>
        <div className='form-list-radio'>
          {_.map(EXISTANCE_FLAG, item => {
            return readOnly ? (
              showFormFlag === item.VALUE && (
                <span key={item.VALUE}>{item.TEXT}</span>
              )
            ) : (
              <div className='form-list-radio__item' key={item.VALUE}>
                <label className='radio'>
                  <input
                    type='radio'
                    id={`form-radio-security-information_flag-${item.ID}`}
                    value={item.VALUE}
                    checked={showFormFlag === item.VALUE}
                    name='security_company_branch_permission_flag'
                    onChange={e => this.handleToggleShowForm(e)}
                  />
                  <RadioButtonIcon className='icon--2x' />
                  <span>{item.TEXT}</span>
                </label>
              </div>
            );
          })}
        </div>
      </FormElement>
    );
  };

  isShowWarning = () => {
    const { companySecurityValues } = this.props;
    if (_.get(companySecurityValues, 'id')) {
      return (
        isNullOrEmpty(companySecurityValues.prefectures_code_id) ||
        _.isEmpty(companySecurityValues.permission_number_r) ||
        _.isEmpty(companySecurityValues.license_update_date)
      );
    }
    return false;
  };

  renderDescription = () => {
    const { readOnly } = this.props;
    return (
      readOnly &&
      this.isShowWarning() && (
        <FormListItem className='form-list__item form-list__item-description'>
          <Description type='primary'>
            警備業許可情報の登録内容に誤りがあります。正しい情報に更新してください。
          </Description>
        </FormListItem>
      )
    );
  };

  render() {
    const { formValues, showFormFlag, validate, warningMsg } = this.state;
    const { readOnly, documentCodes } = this.props;
    return (
      <div
        className='CompanySecurityInformation'
        id='CompanySecurityInformation'
      >
        <FormListSubHeader title='警備業許可情報' />
        {this.renderDescription()}
        <FormListItem label='警備業許可有無' required={!readOnly}>
          {this.renderRegistrationSecurity()}
        </FormListItem>
        {!!showFormFlag && (
          <CompanySecurityInformationForm
            readOnly={readOnly}
            validate={validate}
            formValues={formValues}
            formEvents={this.formEvents}
            documentCodes={documentCodes}
            warningMsg={warningMsg}
          />
        )}
      </div>
    );
  }
}

export const CompanySecurityInformationForm = ({
  readOnly,
  formEvents,
  validate,
  formValues,
  documentCodes,
  warningMsg,
}) => {
  const renderPrefecture = () => {
    return (
      <FormElement validate={_.get(validate, 'messages.prefectures_code_id')}>
        <div className='form-list-radio__item'>
          <select
            name='prefectures_code_id'
            disabled={readOnly}
            onChange={e => formEvents.handleOnChange(e)}
            value={formValues.prefectures_code_id}
            onBlur={e => formEvents.handleValidate(e, 'prefectures_code_id')}
          >
            {!readOnly && <option value=''>選択してください</option>}
            {readOnly && !formValues.prefectures_code_id
              ? ''
              : _.map(PREFECTURE_GROUPS, region => (
                  <optgroup key={region.label} label={region.label}>
                    {_.map(region.prefectures, prefecture => (
                      <option key={prefecture.id} value={prefecture.id}>
                        {prefecture.name}
                      </option>
                    ))}
                  </optgroup>
                ))}
          </select>
          <ArrowDownIcon className='icon--2_4x form-list__arrow-icon' />
        </div>
      </FormElement>
    );
  };

  const renderPermissionNumber = () => {
    return (
      <FormElement
        info={!readOnly && messageUtility.getMessage('I-000-146')}
        validate={_.get(validate, 'messages.permission_number_r')}
      >
        <div className='form-list-container'>
          <div className='form-list-container--item'>
            <span className='form-list-container--label-first'>第</span>
            <TextInput
              type='text'
              name='permission_number_r'
              disabled={readOnly}
              value={formValues.permission_number_r}
              onChange={e => formEvents.handleOnChange(e)}
              onBlur={e => formEvents.handleValidate(e, 'permission_number_r')}
              maxLength={20}
            />
            <span className='form-list-container--label-second'>号</span>
          </div>
        </div>
      </FormElement>
    );
  };

  const renderLicenseUpdateDate = () => {
    const { license_update_date } = formValues;
    if (readOnly && !license_update_date) {
      return null;
    }
    return (
      <DateInput
        message={_.get(validate, 'messages.license_update_date')}
        dateString={dateFormat(license_update_date)}
        disabled={readOnly}
        onChangeValue={date =>
          formEvents.handleOnChangeDate(date, 'license_update_date')
        }
        isPreview={readOnly}
        onBlur={e => formEvents.handleValidate(e, 'license_update_date')}
        jpDelimiterChar={true}
        warning={_.get(warningMsg, 'license_update_date')}
      />
    );
  };

  const renderLastYearUpdate = () => {
    const { license_update_date } = formValues;
    if (readOnly && !license_update_date) {
      return null;
    }
    let licenseLimitDate = '';
    if (isEmptyOrValidInputDate(license_update_date) === false) {
      const licenseUpdateDate = convertDate(license_update_date);
      licenseLimitDate = moment(licenseUpdateDate).isValid()
        ? moment(licenseUpdateDate).add(5, 'years')
        : '';
      if (licenseLimitDate) {
        const [year, month, day] = stringToDate(licenseUpdateDate);
        if (!(Number(month) === 2 && Number(day) === 29)) {
          licenseLimitDate.subtract(1, 'days');
        }
        licenseLimitDate = licenseLimitDate.format(
          DATE_TIME_FORMAT.slashDateFormat
        );
      }
    }
    return (
      licenseLimitDate && (
        <DateInput
          dateString={licenseLimitDate}
          jpDelimiterChar={true}
          disabled={true}
          isPreview={true}
          warning={wrapperValidExpirationDate(
            licenseLimitDate,
            '許可',
            true,
            null,
            '許可（更新）年月日と添付書類'
          )}
        />
      )
    );
  };

  const renderAttachment = () => {
    return (
      <FormElement
        warning={
          !readOnly &&
          _.isEmpty(formValues.company_documents) &&
          '添付書類が添付されておりません。'
        }
      >
        <AttachDocument
          companyDocuments={_.cloneDeep(formValues.company_documents)}
          documentCodes={_.filter(documentCodes, document => {
            return (
              document.file_typeL ===
              ATTACH_DOCUMENT_TYPE_COMPANY.SECURITY_COMPANY_PERMISSION
            );
          })}
          events={formEvents}
          isFormListDefault={true}
          indexId={ATTACH_DOCUMENT_TYPE_COMPANY.SECURITY_COMPANY_PERMISSION}
          readOnly={readOnly}
        />
      </FormElement>
    );
  };

  const dateFormat = date => {
    return date ? date : '//';
  };

  return (
    <React.Fragment>
      <FormListItem
        label='公安委員会'
        required={!readOnly}
        safetyDocItem={true}
      >
        {renderPrefecture()}
      </FormListItem>
      <FormListItem
        label='許可番号 固有番号'
        required={!readOnly}
        safetyDocItem={true}
      >
        {renderPermissionNumber()}
      </FormListItem>
      <FormListItem
        label='許可（更新）年月日'
        required={!readOnly}
        safetyDocItem={true}
      >
        {renderLicenseUpdateDate()}
      </FormListItem>
      <FormListItem label='有効期限年月日'>
        {renderLastYearUpdate()}
      </FormListItem>
      <FormListItem label='添付書類'>{renderAttachment()}</FormListItem>
    </React.Fragment>
  );
};

export default CompanySecurityInformation;



// WEBPACK FOOTER //
// ./src/components/CompanySecurityInformation.jsx